import { MSG_OBG_ASSUNTO, MSG_OBG_CLASSIFICACAO, MSG_OBG_MUNICIPIO, MSG_OBG_CARTORIO, MSG_OBG_DESCRICAO, MSG_LIMITE_DESCRICAO, ERRO_FORMULARIO_INVALIDO } from './../../../tools/Mensagens';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { OK_MANIFESTO_ENVIADO, ERRO_DADOS_NAO_GRAVADOS } from 'src/app/tools/Mensagens';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { CriticaService } from 'src/app/service/critica/critica.service';
import { PAGINA_SUCESSO_FORM } from 'src/app/tools/URL';

@Component({
  selector: 'critica',
  templateUrl: './critica.component.html',
  styleUrls: ['./critica.component.css']
})
export class CriticaComponent implements OnInit {
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;
  nome = this.authService.usuarioDTO.nome;
  email = this.authService.usuarioDTO.email;
  alerts: String = '';


  constructor(
    public service: CriticaService,
    public authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.service.carregarDados().subscribe(retorno => {
      this.service.critica.controls.nome.setValue(this.authService.usuarioDTO.nome);
      this.service.critica.controls.email.setValue(this.authService.usuarioDTO.email);
      if (retorno) {
        this.service.critica.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.service.critica.controls.listaCartorio.setValue(retorno.listaCartorio);
        this.service.critica.controls.assuntos.setValue(retorno.assuntos);
      }
    });

    this.service.critica.controls.descricaoCritica.setValue('');
    this.service.critica.controls.municipio.setValue('');
    this.service.critica.controls.cartorio.setValue('');
  }

  onSubmit() {
    this.validarFormulario();
    if (this.service.critica.value.assunto) {
      this.preencherDadosCritica();
      if (this.service.critica.valid) {

        if(this.service.critica.controls.cartorio) {

          const cartorio = this.service.critica.value.listaCartorio
          .find(cartorio => cartorio.nomeServico === this.service.critica.controls.cartorio.value && cartorio.id.municipio.nome === this.service.critica.controls.municipio.value);
          this.service.critica.value.cartorio = cartorio;

        }

        this.service.enviar(this.service.critica.value).subscribe(retorno => {
          if (retorno) {
            alert(OK_MANIFESTO_ENVIADO);
            this.router.navigate([PAGINA_SUCESSO_FORM]);
          } else {
            alert(ERRO_DADOS_NAO_GRAVADOS);
          }
        });
      } else {
        alert(ERRO_FORMULARIO_INVALIDO)
      }
    }
  }

  preencherDadosCritica() {
    this.service.critica.value.nome = this.authService.usuarioDTO.nome;
    this.service.critica.value.email = this.authService.usuarioDTO.email;
    this.service.critica.value.files = [];
    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      this.service.critica.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });
  }

  validarFormulario() {
    this.alerts = '';
    if (this.service.critica.value.assunto == null || this.service.critica.value.assunto === '') {
      this.alerts = this.alerts + MSG_OBG_ASSUNTO;
    } else {
      if (this.service.critica.value.listaClassificacao.length === 0) {
        this.alerts = this.alerts + MSG_OBG_CLASSIFICACAO;
      }
      switch (this.service.critica.value.assunto.value) {
        case 'cartorios_extrajudiciais_critica': {
          if (this.service.critica.value.municipio === '') {
            this.alerts = this.alerts + MSG_OBG_MUNICIPIO;
            this.service.critica.controls['municipio'].setErrors({});
          }
          if (this.service.critica.value.cartorio === '') {
            this.service.critica.controls['cartorio'].setErrors({});
            this.alerts = this.alerts + MSG_OBG_CARTORIO;
          }
          if (this.service.critica.value.descricaoCritica === ''
            || this.service.critica.value.descricaoCritica == null) {
            this.alerts = this.alerts + MSG_OBG_DESCRICAO;
          } else if (this.service.critica.value.descricaoCritica.length < 0
            && this.service.critica.value.descricaoCritica.length > 5000) {
            this.alerts = this.alerts + MSG_LIMITE_DESCRICAO;
          }
          break;
        }
        case 'natureza_administrativa_critica': {
          this.service.critica.controls['cartorio'].setValue(null);
          this.service.critica.controls['cartorio'].setErrors(null);
          this.service.critica.controls['municipio'].setValue(null);
          this.service.critica.controls['municipio'].setErrors(null);

          if (this.service.critica.value.descricaoCritica === ''
            || this.service.critica.value.descricaoCritica == null) {
            this.alerts = this.alerts + MSG_OBG_DESCRICAO;
          } else if (this.service.critica.value.descricaoCritica.length < 0
            && this.service.critica.value.descricaoCritica.length > 5000) {
            this.alerts = this.alerts + MSG_LIMITE_DESCRICAO;
          }
          break;
        }
      }
    }
    if (this.alerts.length > 0) {
      alert(this.alerts);
    }
  }

  desmarcarCheckOutrosAssuntos() {
    this.service.critica.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);
    this.service.critica.controls.descricaoCritica.reset();
  }

  changeAssunto(item) {
    this.service.critica.controls.assunto.setValue(item);

    this.service.critica.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);

    this.service.critica.value.assuntos
      .filter(assunto => assunto.id === item.id)
      .forEach((assunto: any) => assunto.selected = true);

    this.service.critica.value.assuntos
      .filter(assunto => assunto.id !== item.id)
      .forEach((assunto: any) => assunto.selected = false);

    this.resetFormControl();
  }

  resetFormControl() {
    this.service.critica.controls.descricaoCritica.setValue('');
    this.service.critica.controls.listaClassificacao.setValue([]);
    this.service.critica.controls.localidade.setValue('');
    this.service.critica.controls.municipio.setValue('');
    this.service.critica.controls.cartorio.setValue('');
  }

  isChecked(item) {
    return this.service.critica.controls.assunto.value === item;
  }

  isAssuntoChecked(str) {
    return this.service.critica.value.assunto &&
      this.service.critica.value.assuntos
        .filter((assunto: any) => assunto.selected && assunto.value === str)
        .length > 0 ? true : false;
  }
}
